var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "info-item info-item__project_leaders",
      attrs: { id: "project__list__coordinator" },
      on: { click: _vm.showChangeProjectLead }
    },
    [
      _c(
        "div",
        { staticClass: "info-bubbles exclude-outside-click" },
        [
          _vm._l(_vm.project.project_leaders, function(u, index) {
            return u.id
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.html",
                        modifiers: { hover: true, html: true }
                      }
                    ],
                    staticClass:
                      "initials badge badge-primary cursor-pointer exclude-outside-click",
                    attrs: { title: u.name }
                  },
                  [
                    _c("span", { staticClass: "exclude-outside-click" }, [
                      _vm._v(_vm._s(_vm._f("textInitials")(u.name)))
                    ])
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("plus-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.addProjectLeadFlag,
                expression: "!addProjectLeadFlag"
              },
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.html",
                modifiers: { hover: true, html: true }
              }
            ],
            staticClass: "tagged-contacts plus-button plus-button--small",
            style: _vm.project.project_leaders ? "" : "margin-left: 22px;",
            attrs: {
              title:
                (_vm.project.project_leaders ? "Change " : "Add ") +
                "" +
                _vm.getSystemSetting("project__project_lead_label")
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.addProjectLeadFlag,
              expression: "addProjectLeadFlag"
            }
          ],
          staticClass: "add-multiselect-group"
        },
        [
          _c(
            "div",
            { staticClass: "custom-field user-field custom-multiselect" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addProjectLeadFlag,
                    expression: "addProjectLeadFlag"
                  }
                ],
                ref: "projectLead",
                attrs: {
                  options: _vm.allActiveUsers,
                  "option-height": 42,
                  "show-labels": false,
                  multiple: true,
                  "allow-empty": false,
                  label: "name",
                  "track-by": "id"
                },
                on: {
                  close: function($event) {
                    _vm.addProjectLeadFlag = false
                  },
                  input: function($event) {
                    return _vm.projectLeadChanged()
                  }
                },
                model: {
                  value: _vm.project.project_leaders,
                  callback: function($$v) {
                    _vm.$set(_vm.project, "project_leaders", $$v)
                  },
                  expression: "project.project_leaders"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }